import React from 'react';
import { MBModalPopup } from '@shared/components/modal';
import { MBUrgentModalContent, MBUrgentModalContentProps } from './content';

export interface MBUrgentModalProps extends MBUrgentModalContentProps {
  visible: boolean;
}

export function MBUrgentModalComponent({ visible, ...contentProps }: MBUrgentModalProps) {
  return (
    <MBModalPopup animationType="fade" onClose={contentProps.onClose} visible={visible}>
      <MBUrgentModalContent {...contentProps} />
    </MBModalPopup>
  );
}
